import { Component, Vue } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import ArtworkView from '../components/artwork-view/index.vue'
import Application from '../shared/application'

const routes: any[] = [
  {
    path: '/',
    name: 'artists.view',
    component: { template: '<div></div>' },
  },
  {
    path: '/:hash',
    name: 'artworks.view',
    component: ArtworkView,
  },
]

const router = new VueRouter({
  base: _state.baseUrl,
  mode: 'history',
  routes,
})

@Component
class ArtistsView extends Vue {
  public showCount: number = 8

  public get artworksCount(): number {
    return _state.artworks.length
  }

  public get hasMoreThumbs(): boolean {
    return this.showCount < this.artworksCount
  }

  public openArtwork(hash: string) {
    this.$router.push({name: 'artworks.view', params: {hash}})
  }

  public showAllThumbs() {
    const f = () => {
      setTimeout(() => {
        this.showCount++

        if (this.showCount < this.artworksCount) {
          f()
        }
      }, 80)
    }

    f()
  }
}

export default new Application(ArtistsView, router)
